<script setup>
/**
 * @fileoverview FireclayTileLogoHorizontal component.
 *
 * Displays the Fireclay Tile horizontal logo as an inline SVG.
 * The logo includes the iconic tile grid symbol and "FIRECLAY TILE" wordmark.
 *
 * @component
 */

defineProps({
    /**
     * Accessible label for the SVG logo, read by screen readers.
     * @type {string}
     */
    ariaLabel: {
        type: String,
        default: 'Fireclay Tile logo',
    },
});
</script>

<template>
    <svg viewBox="11.88 12.57 176.33 44.86" role="img" :aria-label="ariaLabel">
        <path
            class="cls-1"
            d="M11.88,57.43h44.86V12.57H11.88v44.86ZM53.48,31.43v22.75h-17.55v-22.75h17.55ZM53.48,15.82v12.35h-17.55v-12.35h17.55ZM32.68,15.82v38.35H15.13V15.82h17.55Z"
        ></path>
        <polygon
            class="cls-1"
            points="68.45 25.27 76.88 25.27 76.88 22.4 68.45 22.4 68.45 17.63 77.7 17.63 77.72 14.74 65.27 14.74 65.27 32.41 68.45 32.41 68.45 25.27"
        ></polygon>
        <rect class="cls-1" x="81.99" y="14.74" width="3.19" height="17.67"></rect>
        <path
            class="cls-1"
            d="M104.19,20.81c0-3.86-2.6-6.07-7.14-6.07h-7.19v17.67h3.19v-5.25h4.01c.24,0,.5,0,.73-.02l3.18,5.27h3.64l-3.95-5.89c2.29-.95,3.54-2.97,3.54-5.71ZM101.16,20.89c0,2.21-1.42,3.38-4.11,3.38h-4.01v-6.64h4.01c2.72,0,4.11,1.1,4.11,3.26Z"
        ></path>
        <polygon
            class="cls-1"
            points="110.69 24.97 119.2 24.97 119.2 22.08 110.69 22.08 110.69 17.63 120.2 17.63 120.2 14.74 107.51 14.74 107.51 32.41 120.5 32.41 120.5 29.52 110.69 29.52 110.69 24.97"
        ></polygon>
        <path
            class="cls-1"
            d="M137.17,27.52c-1.32,1.27-3.1,2.03-4.76,2.03-3.42,0-6.09-2.64-6.09-6.02s2.68-6,6.09-6c1.72,0,3.5.81,4.76,2.17l.1.11,1.88-2.34-.08-.08c-1.73-1.71-4.24-2.72-6.71-2.72-5.2,0-9.28,3.9-9.28,8.88s4.03,8.98,9.18,8.98c2.44,0,4.99-1.08,6.83-2.9l.08-.08-1.91-2.13-.09.09Z"
        ></path>
        <polygon
            class="cls-1"
            points="145.91 14.74 142.72 14.74 142.72 32.41 153.45 32.41 153.45 29.5 145.91 29.5 145.91 14.74"
        ></polygon>
        <path
            class="cls-1"
            d="M166.36,14.74h-3.17l-7.72,17.49-.08.18h3.33l1.67-3.93h8.62l1.67,3.93h3.41l-7.69-17.59-.03-.07ZM167.79,25.61h-6.19l3.1-7.29,3.1,7.29Z"
        ></path>
        <polygon
            class="cls-1"
            points="184.94 14.74 180.14 23.1 175.27 14.8 175.23 14.74 171.99 14.74 178.57 26.62 178.57 32.41 181.73 32.41 181.73 26.52 188.11 14.93 188.21 14.74 184.94 14.74"
        ></polygon>
        <polygon
            class="cls-1"
            points="65.27 40.55 70.25 40.55 70.25 55.33 73.44 55.33 73.44 40.55 78.45 40.55 78.45 37.67 65.27 37.67 65.27 40.55"
        ></polygon>
        <rect class="cls-1" x="82.09" y="37.67" width="3.19" height="17.67"></rect>
        <polygon
            class="cls-1"
            points="93.66 37.67 90.47 37.67 90.47 55.33 101.2 55.33 101.2 52.42 93.66 52.42 93.66 37.67"
        ></polygon>
        <polygon
            class="cls-1"
            points="107.81 47.89 116.32 47.89 116.32 45.01 107.81 45.01 107.81 40.55 117.32 40.55 117.32 37.67 104.63 37.67 104.63 55.33 117.62 55.33 117.62 52.45 107.81 52.45 107.81 47.89"
        ></polygon>
    </svg>
</template>

<style>
.cls-1 {
    fill: #231f20;
    stroke-width: 0px;
}
</style>
